import React from 'react';

import TicketCard from './TicketCard';

const TicketCards = ({ tickets }) => {
  if (!tickets?.length) {
    return <></>;
  };

  return (
    <div className='rs-pricing style2 pricing-home6-style sponsor pt-20 pb-20 md-pt-15 md-pb-15'>
      <div className='row'>
        {tickets.map(({ title, currency, price, text, warningIcon, warningText, buttonText, link }, i) => {
          return (
            <TicketCard
              key={i}
              title={title}
              currency={currency}
              price={price}
              text={text}
              warningIcon={warningIcon}
              warningText={warningText}
              buttonText={buttonText}
              link={link}
            />
          );
        })}
      </div>
    </div>
  );
};

export default TicketCards;
